export default [{
  // Checkout page
  component: function component() {
    return import('pages/checkout/Checkout');
  },
  meta: {
    layout: 'Main',
    title: 'route.checkout'
  },
  path: '/checkout'
}, {
  // Recommend page
  component: function component() {
    return import('pages/checkout/Recommend');
  },
  meta: {
    layout: 'Main',
    title: 'route.recommend'
  },
  path: '/recommend'
}, {
  // Share page
  component: function component() {
    return import('pages/checkout/Share');
  },
  meta: {
    layout: 'Main',
    title: 'route.share'
  },
  path: '/share'
}, {
  // Thank You page
  component: function component() {
    return import('pages/checkout/ThankYou');
  },
  meta: {
    layout: 'Default',
    title: 'route.thankYou'
  },
  path: '/thank-you'
}, {
  // Upload page
  component: function component() {
    return import('pages/checkout/Upload');
  },
  meta: {
    layout: 'Main',
    title: 'route.upload'
  },
  path: '/upload'
}];